import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../services/apiService';

const BASE_URL = 'https://admin.defconinnovations.com/advocateapi';

export const useCaseStudy = () => {
  const queryClient = useQueryClient();

  const useGetCaseStudies = () =>
    useQuery({
      queryKey: ['case-studies'],
      queryFn: () => apiService.get(BASE_URL, '/case-studies/'),
    });

  const useAddCaseStudy = () =>
    useMutation({
      mutationFn: data => apiService.post(BASE_URL, '/case-studies/', data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['case-studies'] });
      },
    });

  const useUpdateCaseStudy = () =>
    useMutation({
      mutationFn: ({ id, data }) =>
        apiService.patch(BASE_URL, `/case-studies/${id}/`, data),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['case-studies'] });
      },
    });

  const useDeleteCaseStudy = () =>
    useMutation({
      mutationFn: id =>
        apiService.patch(BASE_URL, `/case-studies/${id}/`, {
          is_archive: true,
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['case-studies'] });
      },
    });

  return {
    useGetCaseStudies,
    useAddCaseStudy,
    useUpdateCaseStudy,
    useDeleteCaseStudy,
  };
};
